import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import getUrlParams from 'toxilibs/url_params.js'

const {theme, returnUrl} = getUrlParams()


function onResize () {
    const height = $(window).height()

    const teacherHeight = height < 760 ? height * 0.9 : 712
    const hourOfCodeLogoHeight = Math.floor(teacherHeight * 0.2)

    $('#hour_of_code_welcome').css({
        height: hourOfCodeLogoHeight + 'px',
        bottom: ((height - teacherHeight) * 0.5) + 10 + 'px',
        left:   $(window).width() * 0.5 + teacherHeight * 0.342 - 1.25 * hourOfCodeLogoHeight + 'px'
    })

    $('#main').css('min-height', (height - 150 - 80) + 'px')
}


function init () {

    if (theme === 'basic_python') {
        $('body').append('<img src="https://code.org/api/hour/begin_toxicode_python.png">')
    } else {
        $('body').append('<img src="https://code.org/api/hour/begin_silent_teacher.png">')
    }

    $(window).on('resize', onResize)
    onResize()
}



function displayEnd () {
    if (returnUrl) {
        return
    }
    $('body').append('<img src="https://code.org/api/hour/finish_silent_teacher.png" />')
    setTimeout(function () {
        window.location.href = 'https://code.org/api/hour/finish'
    }, 2000)
}


export default function () {
    eventBus.on('welcome loaded', init)
    eventBus.on('end', displayEnd)
}

